import { Box, Button, Text, VStack, HStack, Icon } from "@chakra-ui/react";
import { useRef } from "react";
import { BiUpload, BiFile, BiX } from "react-icons/bi";
import colors from "core/resources/theme/colors";

interface FileUploadProps {
  onFileSelect: (file: File | null) => void;
  selectedFile: File | null;
  isInvalid?: boolean;
}

export default function FileUpload({ onFileSelect, selectedFile, isInvalid }: FileUploadProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    if (file) {
      const validTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
      if (validTypes.includes(file.type)) {
        onFileSelect(file);
      } else {
        alert('Formato de arquivo não suportado. Use PNG, JPG, JPEG ou PDF.');
        event.target.value = '';
      }
    }
  };

  const handleRemoveFile = () => {
    onFileSelect(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <VStack spacing={3} align="stretch">
      <input
        ref={fileInputRef}
        type="file"
        accept=".png,.jpg,.jpeg,.pdf"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      
      {!selectedFile ? (
        <Button
          onClick={() => fileInputRef.current?.click()}
          variant="outline"
          borderColor={isInvalid ? "red.500" : colors.gray300}
          borderStyle="dashed"
          h="100px"
          w="100%"
          flexDirection="column"
          gap={2}
        >
          <Icon as={BiUpload} boxSize={6} />
          <Text fontSize="sm" textAlign="center">
            Clique para selecionar o arquivo
            <br />
            PNG, JPG, JPEG ou PDF
          </Text>
        </Button>
      ) : (
        <Box
          border="1px solid"
          borderColor={colors.gray300}
          borderRadius="md"
          p={3}
        >
          <HStack justify="space-between">
            <HStack>
              <Icon as={BiFile} boxSize={5} />
              <Text fontSize="sm" noOfLines={1}>
                {selectedFile.name}
              </Text>
            </HStack>
            <Button
              size="sm"
              variant="ghost"
              onClick={handleRemoveFile}
              colorScheme="red"
            >
              <Icon as={BiX} boxSize={4} />
            </Button>
          </HStack>
        </Box>
      )}
    </VStack>
  );
}